/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: directory-edit-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */

function DirectoryEditViewController (
    this: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    BreadcrumbService: JS5Object,
    DirectoryService: JS5Object,
    DirectoryEditService: JS5Object,
    FileSystemService: JS5Object,
    SidebarService: JS5Object,
) {

    //================//
    // Template Logic //
    //================//

    const pathRequirementsByType: JS5Object = {
        AWS: [{
            getDescription: () => 'AWS path must end with a "/"',
            isValid: () => this.directoryObject && _.endsWith(this.directoryObject.path, '/'),
        }]
    };

    this.editingNewDirectory = () => {
        return $routeParams.directoryId === '-1';
    };

    //=========//
    // Toolbar //
    //=========//

    const saveEditData = () => {
        let savePromise: JS5Promise;
        this.loadingIndicator.show = true;
        if (this.editingNewDirectory()) {
            savePromise = DirectoryService.createDirectory(this.directoryObject);
        } else {
            savePromise = DirectoryService.updateDirectory(this.directoryObject);
        }
        savePromise.then((directory: JS5Object) => {
            this.originalEditData = _.cloneDeep(directory);
            this.directoryObject = directory;
            this.editorForm.$setPristine();
            $route.updateParams({id: $routeParams.id, directoryId: directory.id});
        })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const revertEditData = () => {
        this.directoryObject = _.cloneDeep(this.originalEditData);
        this.editorForm.$setPristine();
        if (this.editingNewDirectory()) {
            exitEdit();
        }
    };

    const exitEdit = () => {
        let fileSystemId = $routeParams.id;
        $location.url(`/system/fileSystems/edit/${fileSystemId}/directories`);
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !this.editorForm.$pristine && this.editorForm.$valid,
            onClick: saveEditData
        }, {
            label: 'Revert',
            enabled: () => !this.editorForm.$pristine || this.editingNewDirectory(),
            onClick: revertEditData
        }, {
            label: 'Close',
            enabled: () => this.editorForm.$pristine && !this.editingNewDirectory(),
            onClick: exitEdit
        }
    ];


    //=================//
    // Lifecycle Hooks //
    //=================//

    const setBreadcrumbData = (fileSystem: JS5Object) => {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            location: '/system/fileSystems/search',
            name: 'File Systems',
        });
        BreadcrumbService.addBreadcrumb({
            location: `/system/fileSystems/edit/${fileSystem.id}/directories`,
            name: fileSystem.name,
        });
    };

    const getData = () => {
        let promises = [];
        this.loadingIndicator.show = true;
        promises.push(FileSystemService.getFileSystem($routeParams.id)
            .then((fileSystem: JS5Object) => {
                this.pathRequirements = pathRequirementsByType[fileSystem.typeName];
                setBreadcrumbData(fileSystem);
            }));

        if (this.editingNewDirectory()) {
            this.directoryObject = _.get(this, 'directoryObject', {
                filesystemId: $routeParams.id,
                defaultPermissionRead: true,
                defaultPermissionWrite: true,
            });
            this.originalEditData = _.cloneDeep(this.directoryObject);
        } else {
            promises.push(DirectoryService.getDirectory($routeParams.directoryId)
                .then((directory: JS5Object) => {
                    this.originalEditData = _.cloneDeep(directory);
                    this.directoryObject = directory;
                }));
        }
        $q.all(promises).then(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };

    this.$postLink = () => {
        DirectoryEditService.editorForm = this.editorForm;
        SidebarService.editService = DirectoryEditService;
    }
}

angular.module('prism-ui.fileSystem').component('directoryEditView', {
    templateUrl: 'system/fileSystem/editView/directory/editView/directory-edit-view-template.html',
    controller: DirectoryEditViewController
});
